import { render } from "./sysAdmin.vue?vue&type=template&id=a188968e"
import script from "./sysAdmin.vue?vue&type=script&lang=js"
export * from "./sysAdmin.vue?vue&type=script&lang=js"

import "./sysAdmin.vue?vue&type=style&index=0&id=a188968e&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__